import { buildGenericPropertyComponent } from '../components/GenericPropertyComponent';
import { PropertySchema } from '../PropertySchema';

export const IntegerProperty = new PropertySchema('integer', {
  component: buildGenericPropertyComponent({
    parseValue(value: string): number {
      const parsedValue = parseInt(value, 10);

      if (Number.isNaN(parsedValue)) {
        return 0;
      }

      return parsedValue;
    },

    formatValue(value: number): string {
      return value.toString();
    },
  }),
});
